<template>
  <div class="flex -mx-2">
    <div class="w-1/2 px-2">
      <ColorPicker
        name="primaryColor"
        :color="primaryColor"
        :loading="loading"
        @color-selected="onColorSelected"
      >
        <label
          slot="label"
          class="subtitle"
        >
          Primary
        </label>
      </ColorPicker>
    </div>
    <div class="w-1/2 px-2">
      <ColorPicker
        name="secondaryColor"
        :color="secondaryColor"
        :loading="loading"
        @color-selected="onColorSelected"
      >
        <label
          slot="label"
          class="subtitle"
        >
          Secondary
        </label>
      </ColorPicker>
    </div>
  </div>
</template>

<script>
import ColorPicker from "@/components/UI/ColorPicker";

export default {
  name: "BrandColours",
  components: { ColorPicker },
  props: {
    loading: Boolean,
    primaryColor: {
      required: true,
      type: String
    },
    secondaryColor: {
      required: true,
      type: String
    }
  },
  methods: {
    onColorSelected(color) {
      this.$emit("color-selected", color);
    }
  }
};
</script>

<style scoped>
.subtitle {
  @apply text-grey-dark text-xs font-normal mt-1 ml-1 italic;
}
</style>
